var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RowColumn',[_c('Pagination',{attrs:{"search":_vm.search,"base-url":_vm.baseUrl,"total-items":_vm.totalItems,"method-name":_vm.methodName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }